/**
 * Copyright Aquera Inc 2025
 *
 * This source code is licensed under the BSD-3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { css } from 'lit';

/**
 * CarouselItem CSS
 */
export const styles = css`
  :host {
    display: block;
    scroll-snap-align: start;
    scroll-snap-stop: always;
  }

  .carousel-item {
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
  }

  :host([hidden]) {
    display: none;
  }
`;

export default [styles];

